import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "invoiceforge_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setVisible(true);
  }, []);

  const accept = (all) => {
    localStorage.setItem(KEY, all ? "all" : "essential");
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50" data-testid="cookie-banner">
      <div className="card-flat bg-white shadow-lg border-l-4 border-l-[var(--primary)] p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-[var(--primary)]/10 grid place-items-center shrink-0">
            <Cookie className="w-4 h-4 text-[var(--primary)]" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm">Cookies &amp; local cache</div>
            <p className="text-xs text-gray-600 mt-1.5 leading-relaxed">
              We use essential cookies to keep you signed in and cache to speed up InvoiceForge. No trackers,
              no ads. See our <Link to="/terms" className="underline underline-offset-2 text-[var(--fg)]" data-testid="cookie-terms-link">Terms &amp; Conditions</Link> for details.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <button
                onClick={() => accept(true)}
                className="text-xs px-4 h-9 bg-[var(--fg)] text-white rounded-md hover:bg-black"
                data-testid="cookie-accept-all"
              >
                Accept all
              </button>
              <button
                onClick={() => accept(false)}
                className="text-xs px-4 h-9 border border-[var(--border)] rounded-md hover:bg-gray-50"
                data-testid="cookie-accept-essential"
              >
                Essential only
              </button>
            </div>
          </div>
          <button onClick={() => setVisible(false)} className="p-1 hover:bg-gray-100 rounded" data-testid="cookie-dismiss">
            <X className="w-4 h-4 text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
